import ApiClient        from './ApiClient.js';

import AccountAPI       from './Account.js';

function makeApiList({
    apiPrefix,
    apiUrl,
    onResponse
} = {}) {
    if (!apiPrefix) throw new Error('[apiPrefix] required');
    if (!apiUrl) throw new Error('[apiUrl] required');

    const api = new ApiClient({ apiUrl, prefix: apiPrefix, onResponse });

    return {
        apiClient      : api,
        account        : new AccountAPI({ apiClient: api })
    };
}

export default makeApiList;
